import React from 'react';

const FooterTaskbar: React.FC = () => <footer className="footer"></footer>;

export default FooterTaskbar;
